import React, { useCallback, useState } from "react";
import CustomEmptyView from "../../../Components/CustomEmptyView";
import TransportHeader from "./Controller/TransportHeader";
import TransportBody from "./Controller/TransportBody";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../Components/Pagination";
import Colors from "../../../theme/Colors";
import DeleteConfirmationPopup from "../../../Components/DeleteConfirmationPopup";
import { useDispatch } from "react-redux";
import { deleteTransportAPI } from "../../../Store/Action/transportAction";
import { toast } from "react-toastify";
import Strings from "../../../Config/Strings";
import Icons from "../../../Config/Images";

const TransportTable = ({
  transportData,
  handleChangePage,
  totalItems,
  rowsPerPage,
  getTransportRefresh,
}) => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [transportIdToDelete, setTransportIdToDelete] = useState(null);

  // Calculate total pages based on totalItems and rowsPerPage

  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleChangePage(null, newPage - 1); // Adjusting index as per 0-based index system
  };
  const navigate = useNavigate();
  const onViewTransportDetails = useCallback(
    (transportData) => {
      navigate(`/admin/transport/${transportData?.transport_id}`, {
        state: { transportData },
      });
    },
    [navigate]
  );

  const onEditTransportDetails = useCallback(
    (transport) => {
      navigate(`/admin/transport/edit-transport`, {
        state: { transport, editForm: true },
      });
    },
    [navigate]
  );

  const handleShowDeleteModal = useCallback((transportData) => {
    setShowDeleteModal(true);
    setTransportIdToDelete(transportData.transport_id);
  }, []);
  const handleCancelDelete = useCallback(() => setShowDeleteModal(false), []);
  const handleDeleteTransport = async () => {
    try {
      await dispatch(
        deleteTransportAPI(transportIdToDelete, (response) => {
          setShowDeleteModal(false);
          if (response?.status) {
            toast.success(response?.message?.message);
            getTransportRefresh();
          } else {
            const errorMessage =
              response?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching deleteUserAPI:", error);
      toast.error(Strings.somethingWentWrongError);
    }
  };
  return (
    <>
      <div style={mainContainerTransport}>
        <div style={outerWrapper}>
          <div style={tableWrapper}>
            <div style={{ height: "92%", minWidth: "110%" }}>
              {transportData?.length === 0 ||
              transportData?.length === undefined ||
              transportData?.length === null ? (
                <div style={{ width: "70vw" }}>
                  <CustomEmptyView />
                </div>
              ) : (
                <>
                  <table style={table}>
                    <TransportHeader />
                    <TransportBody
                      transportDetails={transportData}
                      onViewTransportDetails={onViewTransportDetails}
                      onEditTransportDetails={onEditTransportDetails}
                      handleShowDeleteModal={handleShowDeleteModal}
                    />
                  </table>
                </>
              )}
            </div>

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
          {showDeleteModal && (
            <DeleteConfirmationPopup
              isVisible={showDeleteModal}
              onCancel={handleCancelDelete}
              onDelete={handleDeleteTransport}
              title={Strings.deleteTitle}
              icons={Icons.deleteWithCircle}
            />
          )}
        </div>
      </div>
    </>
  );
};

const mainContainerTransport = {
  borderRadius: "10px",
  height: "78%",
  marginTop: "25px",
  marginLeft: "22px",
  width: "97%",
};

const outerWrapper = {
  borderRadius: "4px",
  boxShadow: "0px 0px 3px #e6e6e6",
  maxWidth: "100%",
  height: "100%",
  backgroundColor: Colors.white,
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableWrapper = {
  overflowY: "scroll",
  // overflowX: "hidden",
  height: "100%",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};

export default TransportTable;
